<template>
  <section class="int-body" data-screen-label="Error">
    <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/interior-bg.jpg" alt="" aria-hidden="true" class="int-bg" decoding="async">
    <div class="int-accents" aria-hidden="true">
      <img class="accent accent--md" src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-blimp-medium.png" alt="" decoding="async">
      <img class="accent accent--ticket" src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-golden-ticket.png" alt="" decoding="async">
      <img class="accent accent--sm" src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/accent-blimp-small.png" alt="" decoding="async">
    </div>
    <div class="int-body-inner">
      <div class="int-lede">
      </div>

      <div class="reg-card reg-card--narrow">
        <span class="card-glow" aria-hidden="true"></span>
        <div class="reg-card__head">
          <h3>A Little Tune-Up Is Needed</h3>
          <p>It looks like one of our machines needs a quick adjustment before the adventure can continue.</p>
          <p>Please try again in a moment.</p>
        </div>

        <div class="center-actions" style="margin-top:30px;">
          <router-link to="/" class="btn-gold" style="min-width:240px;padding:15px 26px;">Return to Homepage</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  mounted() {
    const edgeGlowInit = (card) => {
      if (!card) return;
      let glow = 0;
      let targetGlow = 0;
      let angle = 0;
      let targetAngle = 0;
      let raf = null;
      const THRESH = 0.60;

      const onMove = (e) => {
        const r = card.getBoundingClientRect();
        const cx = r.width / 2;
        const cy = r.height / 2;
        const dx = e.clientX - r.left - cx;
        const dy = e.clientY - r.top - cy;
        const kx = dx !== 0 ? cx / Math.abs(dx) : Infinity;
        const ky = dy !== 0 ? cy / Math.abs(dy) : Infinity;
        const edge = Math.min(Math.max(1 / Math.min(kx, ky), 0), 1);
        let g = edge < THRESH ? 0 : (edge - THRESH) / (1 - THRESH);
        let deg = Math.atan2(dy, dx) * 180 / Math.PI + 90;
        if (deg < 0) deg += 360;
        const nc = Math.round((deg - 45) / 90) * 90 + 45;
        const cd = Math.abs(((deg - nc + 540) % 360) - 180);
        const corner = Math.max(0, 1 - cd / 45);
        targetGlow = Math.min(g * (0.82 + 0.34 * corner), 1);
        targetAngle = deg;
        start();
      };

      const onLeave = () => {
        targetGlow = 0;
        start();
      };

      const start = () => {
        if (!raf) raf = requestAnimationFrame(step);
      };

      const step = () => {
        glow += (targetGlow - glow) * 0.10;
        let d = ((targetAngle - angle + 540) % 360) - 180;
        angle = (angle + d * 0.14 + 360) % 360;
        card.style.setProperty('--hglow', glow.toFixed(3));
        card.style.setProperty('--hangle', angle.toFixed(1) + 'deg');
        if (Math.abs(targetGlow - glow) > 0.002 || Math.abs(d) > 0.4) {
          raf = requestAnimationFrame(step);
        } else {
          raf = null;
        }
      };

      card.addEventListener('pointermove', onMove);
      card.addEventListener('pointerleave', onLeave);
    };

    const glowCards = Array.from(document.querySelectorAll('.reg-card,.up-panel'));
    glowCards.forEach(edgeGlowInit);

    const toucan = document.querySelector('.verify-toucan');
    const card = document.querySelector('.reg-card');
    if (toucan && card) {
      const placeToucan = () => {
        const r = card.getBoundingClientRect();
        toucan.style.top = (r.top + window.scrollY - (toucan.offsetHeight - 50)) + 'px';
        toucan.style.left = (r.right + window.scrollX - toucan.offsetWidth + 2) + 'px';
      };
      placeToucan();
      window.addEventListener('resize', placeToucan);
      window.addEventListener('load', placeToucan);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeToucan);
      if (!toucan.complete) toucan.addEventListener('load', placeToucan);
    }
  },
};
</script>

<style scoped>

</style>
